import { all } from "redux-saga/effects";

import AuthSaga from "./AuthSaga";
import OnboardingSaga from "./OnboardingSaga";
import CalculatorSaga from "./CalculatorSaga";

export function* sagas() {
  yield all([AuthSaga]);
  yield all([OnboardingSaga]);
  yield all([CalculatorSaga]);
}
